import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isDesktop } from '../../../lib/ep.js';

import ActionButton from '../../builder/ActionButton';
import CopyLink from '../../builder/CopyLink';
import ShareTestMessage from '../../builder/ShareTestMessage';

import ShareFACE from '../share/FB';
import ShareTWIT from '../share/Twitter';
import SharePINT from '../share/Pinterest';
import ShareLINK from '../share/Linkedin';
import ShareMAIL from '../share/SendByMail';
import ShareWHAT from '../share/WhatsApp';
import ShareLINE from '../share/Line';
import ShareTELE from '../share/Telegram';
import ShareTHRE from '../share/Threads';

import FloatingLayerPublic from '../FloatingLayerPublic';
import ButtonCollection from '../../builder/ButtonCollection.js';
import ActionLink from '../../builder/ActionLink.js';

const ShareEntry = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_layer, setDisplayLayer ] = useState(false);

	const promotion = (props.promotion != undefined) ? props.promotion : false;
	const is_multiparticipation = (promotion.multi_participation != undefined && promotion.multi_participation) ? true : false;

	const stage = (props.stage != undefined) ? props.stage : false;
	const user = (props.user != undefined) ? props.user : false;
	if(!promotion || !user || !stage && is_multiparticipation) return null;

	const selectAllText = (element) => {
		var doc = document;
		var text = doc.getElementById(element);
		var range, selection;

		if(doc.body.createTextRange) {
			range = document.body.createTextRange();
			range.moveToElementText(text);
			range.select();
		} else if (window.getSelection) {
			selection = window.getSelection();
			range = document.createRange();
			range.selectNodeContents(text);
			selection.removeAllRanges();
			selection.addRange(range);
		}
	}

	const toggleLayer = () => {
		setDisplayLayer(!display_layer);
	};

	const is_mobile = (!isDesktop()) ? true : false;
	const is_test = (promotion.test != undefined) ? promotion.test : false;

	const networks = (promotion.config.share != undefined && promotion.config.share.networks != undefined) ? promotion.config.share.networks : {};
	const has_facebook = (networks.facebook == undefined || networks.facebook != '0') ? true : false;
	const has_twitter = (networks.twitter == undefined || networks.twitter != '0') ? true : false;
	const has_pinterest = (networks.pinterest == undefined || networks.pinterest != '0') ? true : false;
	const has_linkedin = (networks.linkedin == undefined || networks.linkedin != '0') ? true : false;
	const has_mail = (networks.email == undefined || networks.email != '0') ? true : false;
	const has_whatsapp = (networks.whatsapp == undefined || networks.whatsapp != '0') ? true : false;
	const has_line = (networks.line == undefined || networks.line != '0') ? true : false;
	const has_telegram = (networks.telegram == undefined || networks.telegram != '0') ? true : false;
	const has_threads = (networks.threads == undefined || networks.threads != '0') ? true : false;


	const sharing_type = (props.sharing_type != undefined) ? props.sharing_type : 'recruiting';
	let layer_title = false;
	let layer_label = false;
	let share_type = 'public_entry';
	let share_url = props?.share_url ?? ((user.url != undefined) ? user.url : null);
	let share_page = false;

	const info = props?.share_data ?? (user?.share_data ?? {});
	const domain_url = window?.domain_url ?? (window?.common?.domain ?? window.location.hostname);
	const base_url =  `https://${domain_url}/`;
	let url_encode = null;
	
	switch(sharing_type) {
		case 'recruiting':
		//case 'quiz_result':
		//case 'instant_result':
		default:
			share_page = sharing_type;
			layer_title = i18n("Share");
			//layer_label = i18n("Send this link directly to your contacts and friends so they can participate");
			//en aquest casos dependrem del share_data del php. (info.url)
			if(!share_url)share_url = info?.url ?? `${base_url}p/${promotion.id}?uid=${user.id}`;
			url_encode = info?.urlenc ?? share_url;
			break;
		case 'gallery_voteme':
			if(!share_url)share_url = `${base_url}gallery/${promotion.id}/${stage.id}/${user.id}`;
		case 'gallery_view':
			share_page = 'gallery';
			layer_title = i18n("See my gallery!");
			layer_label = i18n("Send this link directly to your contacts and friends so they can see your entry");
			if(!share_url)share_url = `${base_url}gallery/${promotion.id}/${stage.id}/${user.id}`;
			break;
		case 'public_entry':
			share_page = 'voteme';
			layer_title = i18n("Get more votes!");
			layer_label = i18n("Send this link directly to your contacts and friends so they can vote for this entry");
			if(!share_url)share_url = `${base_url}voteme/${promotion.id}/${user.id}`;
			break;
	}

	if (props?.locale != undefined) {
		share_url += `?lc=${props.locale}`;
		if (url_encode != null) {
			url_encode += `?lc=${props.locale}`;
		}
	}

	const full_action_url = `${share_url}`;
	const full_action_url_encode = !url_encode ? `${share_url}` : `${url_encode}`;

	const share_image = (info.image != undefined) ? info.image : '';
	const _icon = props?.icon ?? 'knk-share';
	const _label= props?.label ?? 'Share';

	const share_props = {
		type:share_type ,
		page:share_page  ,
		user_id:user?.id ?? null,
		promotion_id:promotion?.id ?? null,
	}

	let generic_share_props = {
		_fullclass:'simple_default',
		linkable:!is_test,
		url:full_action_url_encode,
	};
	const type = props?.type ?? 'button';
	
	const container_classes = ['in_top'];
	if(props?.classes ?? false) container_classes.push(props.classes);
	
	return (
		<div class={container_classes.join(' ')}>
			{(type == 'button') && (
				<ButtonCollection _class={{other:'flex_button gui_big_button'}}>
					<ActionButton
						_fullclass='share_btn'
						onClick={toggleLayer}
					>{_label}</ActionButton>
				</ButtonCollection>
			)}

			{(type == 'link') && (
				<ActionLink
					_fullclass='share_btn'
					icon={_icon}
					onClick={toggleLayer}
				>{_label}</ActionLink>
			)}

			{(display_layer) && (
				<FloatingLayerPublic
					backButton={toggleLayer}
					title={(layer_title !== false) ? `<h1>${layer_title}</h1>` : null}
				>
					{(layer_label) && (
						<p class="extra_text in_bottom">{layer_label}.</p>
					)}

					<ShareTestMessage
						is_test={is_test}
					/>

					<ButtonCollection _class={{ other:'share_on_social public_share gui_not_in_bottom_big gui_flex_col gui_flex_align_top' }}>
						{(has_facebook) && (
							<ShareFACE
								{...generic_share_props}
								share={{fbtype:'facebook', url:full_action_url, image:share_image, abrev:'fb', ...share_props}}
							>Facebook</ShareFACE>
						)}

						{(has_twitter) && (
							<ShareTWIT
								{...generic_share_props}
								post={info.postenc}
								share={share_props}
							>Twitter</ShareTWIT>
						)}

						{(has_threads) && (
							<ShareTHRE
								{...generic_share_props}
								post={info.postenc}
								share={share_props}
							>Threads</ShareTHRE>
						)}

						{(has_pinterest) && (
							<SharePINT
								{...generic_share_props}
								post={info.postenc}
								img={share_image}
								share={share_props}
							>Pinterest</SharePINT>
						)}

						{(has_linkedin) && (
							<ShareLINK
								{...generic_share_props}
								post={info.postenc}
								img={share_image}
								share={share_props}
							>Linkedin</ShareLINK>
						)}

						{(has_mail) && (
							<ShareMAIL
								{...generic_share_props}
								subject={info.title}
								post={info.description}
								share={share_props}
							>Email</ShareMAIL>
						)}

						{(is_mobile && has_whatsapp) && (
							<ShareWHAT
								{...generic_share_props}
								post={info.descriptionenc}
								share={share_props}
							>WhatsApp</ShareWHAT>
						)}

						{(is_mobile && has_line) && (
							<ShareLINE
								{...generic_share_props}
								post={info.descriptionenc}
								share={share_props}
							>Line</ShareLINE>
						)}

						{(is_mobile && has_telegram) && (
							<ShareTELE
								{...generic_share_props}
								post={info.descriptionenc}
								share={share_props}
							>Telegram</ShareTELE>
						)}

						
					</ButtonCollection>

					<ul class="share_link original_color_item">
						<li class="copy_label" style={{width:'100%'}}>
							{i18n("Or copy-paste this link")}

							<CopyLink _fullclass="copy_link copy_button" copy_link={full_action_url}>Copy link</CopyLink>
						</li>

						{/*<li id="select_link" class="link cutTextOnOverflow" onClick={() => selectAllText('select_link')}>{full_action_url}</li>*/}
						<li id="select_link" class="link">{full_action_url}</li>
					</ul>
				</FloatingLayerPublic>
			)}
		</div>
	)
}

export default injectIntl(ShareEntry);